import React, { useEffect } from 'react'
import { Box, Container, Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import Page from 'components/Page'

const DocumentPage = ({ title, updated, helmetTitle, bodyFontSize = '0.875rem', children }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Page>
      <Helmet>
        <title>{helmetTitle}</title>
      </Helmet>
      <Container maxWidth="md">
        <Box component="article" my={{ xs: 6, md: 10 }}>
          <Typography
            component="h1"
            variant="h4"
            sx={{ fontWeight: 600, fontSize: { xs: '1.875rem', sm: '2.125rem' } }}
          >
            {title}
          </Typography>
          {updated && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
              Last Updated: {updated}
            </Typography>
          )}
          <Box
            sx={{
              mt: updated ? 4 : 2.5,
              color: 'text.primary',
              '& .subtitle': {
                color: 'text.secondary',
                fontSize: '1.25rem',
                fontWeight: 600,
                mt: 0,
                mb: 2.5,
              },
              '& h2': {
                fontSize: '1.25rem',
                fontWeight: 600,
                lineHeight: 1.35,
                mt: 4,
                mb: 1.5,
              },
              '& h3': {
                fontSize: '1rem',
                fontWeight: 600,
                lineHeight: 1.45,
                mt: 2.5,
                mb: 1,
              },
              '& p, & li': {
                fontSize: bodyFontSize,
                lineHeight: 1.7,
              },
              '& p': { mt: 0, mb: 2 },
              '& ul, & ol': { mt: 1, mb: 2, pl: 3.5 },
              '& li': { mb: 0.75, pl: 0.5 },
              '& ul ul, & ol ul, & ul ol, & ol ol': { mt: 0.75, mb: 0.75 },
              '& a': { color: 'primary.main', fontWeight: 500, overflowWrap: 'anywhere' },
              '& .contact': { mt: 4, pt: 2, borderTop: 1, borderColor: 'divider' },
            }}
          >
            {children}
          </Box>
        </Box>
      </Container>
    </Page>
  )
}

export default DocumentPage
